export default "__VITE_PUBLIC_ASSET__3d94a6b5__"